// extracted by mini-css-extract-plugin
export default {"navigation":"NavLinks_navigation__UOM15","active":"NavLinks_active__EZ5f3"};